module.exports = __webpack_public_path__ + "img/env.4077739.png";